<template>
  <div class="sf-product-grid">
    <v-card class="sf-card sf-card--interactive sf-product-tile"
            flat
            v-bind:key="product.id"
            v-bind:to="{ name: 'supplier', params: { id: product.supplierId } }"
            v-for="product in products">
      <div class="sf-product-tile__media">
        <v-img contain
               height="168"
               v-bind:alt="product.title"
               v-bind:src="product.imageUrl"
               v-if="product.imageUrl != null" />
        <v-icon class="sf-product-tile__placeholder"
                size="48"
                v-else>ti-bottle</v-icon>
        <v-chip class="sf-pill sf-pill--accent sf-product-tile__label"
                x-small
                v-if="product.label">
          {{ product.label }}
        </v-chip>
      </div>
      <div class="sf-product-tile__body">
        <div class="sf-product-tile__title">{{ product.title }}</div>
        <div class="sf-product-tile__lead"
             v-if="product.newText1 != null && product.newText1.length > 0">
          {{ product.newText1 }}
        </div>
        <div class="sf-product-tile__text"
             v-if="product.newText2 != null && product.newText2.length > 0">
          {{ product.newText2 }}
        </div>
      </div>
      <div class="sf-product-tile__footer">
        <span class="sf-muted">{{ product.id }}</span>
        <span class="sf-product-tile__cta">
          {{ $t('toOrderSheet') }}
          <v-icon color="primary"
                  small>ti-arrow-right</v-icon>
        </span>
      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'ProductGrid',
    props: {
      products: Array
    }
  }
</script>

<style scoped>
  .sf-product-grid {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }

  .sf-product-tile {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  .sf-product-tile__media {
    align-items: center;
    background: var(--sf-surface-muted);
    border-bottom: 1px solid var(--sf-border);
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: center;
    min-height: 168px;
    padding: 16px;
    position: relative;
  }

  .sf-product-tile__media >>> .v-image {
    width: 100%;
  }

  .sf-product-tile__placeholder {
    color: var(--sf-text-muted);
  }

  .sf-product-tile__label {
    left: 12px;
    position: absolute;
    top: 12px;
  }

  .sf-product-tile__body {
    flex: 1 1 auto;
    padding: 16px 20px 8px;
  }

  .sf-product-tile__title {
    color: var(--sf-text);
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: -.01em;
    line-height: 1.4;
    margin-bottom: 6px;
  }

  .sf-product-tile__lead {
    color: var(--sf-accent);
    font-size: .875rem;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 4px;
  }

  .sf-product-tile__text {
    -webkit-box-orient: vertical;
    color: var(--sf-text-secondary);
    display: -webkit-box;
    font-size: .875rem;
    -webkit-line-clamp: 3;
    line-height: 1.5;
    overflow: hidden;
  }

  .sf-product-tile__footer {
    align-items: center;
    display: flex;
    font-size: .8125rem;
    justify-content: space-between;
    padding: 8px 20px 16px;
  }

  .sf-product-tile__cta {
    align-items: center;
    color: var(--sf-primary);
    display: inline-flex;
    font-weight: 600;
    gap: 4px;
  }
</style>

<i18n>
  {
    "de": {
      "toOrderSheet": "Zum Ordersatz"
    },
    "en": {
      "toOrderSheet": "Open order sheet"
    }
  }
</i18n>
